/**
 * Thin axios wrapper for the admin dashboard.
 * - Token stored in localStorage under "sm_admin_token".
 * - Auto-attaches Authorization: Bearer header.
 * - On 401, clears the token so <AdminApp> shows the login screen.
 */
import axios from "axios";

const TOKEN_KEY = "sm_admin_token";

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
}
export function setToken(t) {
    try {
        if (t) localStorage.setItem(TOKEN_KEY, t);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore
    }
}
export function clearToken() {
    setToken("");
}

const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`,
});

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearToken();
            // avoid infinite loop if we are already on the login screen
            if (!window.location.pathname.endsWith("/admin")) {
                window.location.href = "/admin";
            }
        }
        return Promise.reject(err);
    }
);

export default api;

export function extractErr(err, fallback = "Errore imprevisto") {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : ""))
            .filter(Boolean)
            .join(" · ") || fallback;
    if (d && typeof d.msg === "string") return d.msg;
    return err?.message || fallback;
}
